import { createSearchItemDataCollectionSelector } from 'Modules/selectors.js';

export const localStorageSelector = (state) => state.localStorage;

export const comparedItemsSelector = createSearchItemDataCollectionSelector(
  localStorageSelector,
  (localStorage) => localStorage.compared,
);
